import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import v4 from 'uuid';
import { getLedgermap, getLedgermapList, getLedgermapParams, getNotification } from '../data/selectors';
import { createLedgermap, editLedgermap, setNotifyDone } from '../data/actions';
import { ledgermapSchema } from '../data/model'
import { Header, Form, Button } from 'semantic-ui-react';
import { Formik, Field, Form as FormikForm } from 'formik';
import { FormikCheckBoxComponent, FormikInputComponent } from '../../../utilities/formUtils';
import userACL from '../../../store/access'
import Notification from '../../../utilities/notificationUtils';
import DiscountOptions from './discountOptions';
import { handleRealBooksLedgerNameOnBlur, handleRealBooksLedgerNameSelection, handleDebitMsilLedgerSelection, handleDebitMsilLedgerOnBlur, handleCreditMsilLedgerSelection, handleCreditMsilLedgerOnBlur, handleDealerDiscountSelection, handleDealerDiscountOnBlur, handleControllingLedgerSelection, handleControllingLedgerOnBlur, validatePAN, validateGSTIN } from '../functions';
import LedgerSearch from '../../ledger_search/components/LedgerSearch';
import CommonSelect from '../../common/components/CommonSelect';
import { getCompanyList } from '../../common/data/selectors';

const LedgermapForm = (props) => {
    const ledgermap = useSelector(state => getLedgermap(state, props))
    const ledgermaplist = useSelector(state => getLedgermapList(state, props))
    const params = useSelector(state => getLedgermapParams(state, props))
    const companyOptions = useSelector(state => getCompanyList(state, props))
    const [savedLedgermapId, setSavedLedgermapId] = useState(false)
    const [msilToggle, setMsilToggle] = useState('no')
    const [taxComputationToggle, setTaxComputationToggle] = useState(0)
    const dispatch = useDispatch()

    const handleSelectChange = (value, setFieldValue, _values, _type, _index, fieldName) => {
        setFieldValue(fieldName, value);
    };

    const saveLedgermap = (values, resetForm) => {
        values.vb_discount_field = (values.vb_discount_field && values.vb_discount_field !== undefined && values.vb_discount_field !== "") ? values.vb_discount_field : null

        values.exception_for_tax_computation = (values.exception_for_tax_computation && values.exception_for_tax_computation !== undefined && (values.exception_for_tax_computation === "y" || values.exception_for_tax_computation == 1)) ? 1 : 0

        if (props.match.path === '/ledgermap/create') {
            userACL.atCreate(values)
            delete values.msilToggle
            if (msilToggle === 'no') {
                values.dr_msil = ""
                values.dr_msil_code = ""
                values.cr_msil = ""
                values.cr_msil_code = ""
                values.dler_disc = ""
                values.dler_disc_code = ""
                values.control_ldgr = ""
                values.control_ldgr_code = ""
                dispatch(createLedgermap(values))
                setSavedLedgermapId(values.id)
            } else {
                dispatch(createLedgermap(values))
                setSavedLedgermapId(values.id)
            }

        }
        if (props.match.path === '/ledgermap/edit/:id') {
            userACL.atUpdate(values)
            delete values.msilToggle
            if (msilToggle === 'no') {
                values.dr_msil = ""
                values.dr_msil_code = ""
                values.cr_msil = ""
                values.cr_msil_code = ""
                values.dler_disc = ""
                values.dler_disc_code = ""
                values.control_ldgr = ""
                values.control_ldgr_code = ""
                dispatch(editLedgermap(values))
                setSavedLedgermapId(values.id)
            } else {
                dispatch(editLedgermap(values))
                setSavedLedgermapId(values.id)
            }
            setTimeout(function () {
                props.history.push(`/ledgermap/list`)
            }, 2000)
        }
        if (props.match.path === '/ledgermap/clone/:id') {
            userACL.atCreate(values)
            delete values.msilToggle
            values.id = v4()
            if (msilToggle === 'no') {
                values.dr_msil = ""
                values.dr_msil_code = ""
                values.cr_msil = ""
                values.cr_msil_code = ""
                values.dler_disc = ""
                values.dler_disc_code = ""
                values.control_ldgr = ""
                values.control_ldgr_code = ""
            }
            dispatch(createLedgermap(values))
            setSavedLedgermapId(values.id)
            setTimeout(function () {
                props.history.push(`/ledgermap/list`)
            }, 2000)
        }
    }

    useEffect(() => {
        if (props.match.path === '/ledgermap/edit/:id' || props.match.path === '/ledgermap/clone/:id') {
            let id = props.match.params.id
            let obj = ledgermaplist[id]
            if (obj) {
                if (obj.dr_msil !== "" && obj.dr_msil !== null) {
                    setMsilToggle("yes")
                }
                if (obj.dr_msil_code !== "" && obj.dr_msil_code !== null) {
                    setMsilToggle("yes")
                }
                if (obj.cr_msil !== "" && obj.cr_msil !== null) {
                    setMsilToggle("yes")
                }
                if (obj.cr_msil_code !== "" && obj.cr_msil_code !== null) {
                    setMsilToggle("yes")
                }
                if (obj.dler_disc !== "" && obj.dler_disc !== null) {
                    setMsilToggle("yes")
                }
                if (obj.dler_disc_code !== "" && obj.dler_disc_code !== null) {
                    setMsilToggle("yes")
                }
                if (obj.control_ldgr !== "" && obj.control_ldgr !== null) {
                    setMsilToggle("yes")
                }
                if (obj.control_ldgr_code !== "" && obj.control_ldgr_code !== null) {
                    setMsilToggle("yes")
                }
            }

        }
    }, [])

    return (
        <div >
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 4px 12px",
            }}>
                <div>
                    <div style={{ fontSize: "17px", fontWeight: 600, color: "#1f2d3d", lineHeight: 1.2 }}>
                        {params.title}
                    </div>
                    <div style={{ fontSize: "12px", color: "#8a96a8", marginTop: "2px" }}>
                        Fill in the ledger mapping details below.
                    </div>
                </div>
            </div>
            <Formik id="ledgermapForm" size="large" width={5}
                initialValues={ledgermap}
                validationSchema={ledgermapSchema}
                onSubmit={(values, { resetForm }) => saveLedgermap(values, resetForm)}
                render={({ handleSubmit, resetForm, onChange, values, handleChange, setFieldValue }) => (
                    <Form as={FormikForm} size="small" className="CustomeForm" width={5} onSubmit={handleSubmit}>
                        <Form.Group widths={4} style={{ paddingBottom: "7px" }}>
                            <Field name="parent_group" label="Parent Group" component={FormikInputComponent} placeholder="PARENT GROUP" isMandatory={true}></Field>
                            <Field name="ledger_type" component={FormikInputComponent} placeholder="LEDGER TYPE" isMandatory={true}></Field>
                            <CommonSelect options={companyOptions} name="cid" classNameGet={"searchType"} isLabel={false} label="RealBooks: Company Name" isTxn='false' isSelection={true} getValue={handleSelectChange} index={0} isDisable={false} defaultTxnType={""} isClearable={true} isMandatory={false} />
                            <Field name="dms_pan" label="DMS: Ledger PAN" component={FormikInputComponent} placeholder="DMS LEDGER PAN" onBlurFunc={validatePAN(dispatch)}></Field>
                        </Form.Group>

                        <Form.Group widths={4} style={{ paddingBottom: "7px" }}>
                            <Field name="dms_gstin" label="DMS: Ledger GSTIN" component={FormikInputComponent} placeholder="DMS LEDGER GSTIN" onBlurFunc={validateGSTIN(dispatch)}></Field>
                            <Field name="dms_name" label="DMS: Ledger Name" component={FormikInputComponent} placeholder="DMS LEDGER NAME" isMandatory={true}></Field>
                            <Field name="dms_id" label="DMS: Ledger ID" component={FormikInputComponent} placeholder="DMS LEDGER ID" isMandatory={true}></Field>
                        </Form.Group>

                        <Form.Group widths={4} style={{ paddingBottom: "7px" }}>
                            <Field name="rlb_pan" label="RealBooks: Ledger PAN" component={FormikInputComponent} placeholder="RLB LEDGER PAN" readOnly={true} className="readOnly"></Field>
                            <LedgerSearch name='rlb_name' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='RealBooks: Ledger Name' className="ledgerSearch" isMandatory={true} getValue={handleRealBooksLedgerNameSelection} onBlurFunction={handleRealBooksLedgerNameOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/ledgermap/edit/:id' || props.match.path === '/ledgermap/clone/:id') ? true : false} values={values} componentType="ledgermapForm" cid={values.cid} />
                            <Field name="rlb_id" label="RealBooks: Ledger ID" component={FormikInputComponent} placeholder="RLB LEDGER ID" readOnly={true} className="readOnly" isMandatory={true}></Field>
                        </Form.Group>
                        <Form.Group widths={4} style={{ paddingBottom: "10px" }}>
                            <Field name="rlb_gstin" label="RealBooks: Ledger GSTIN" component={FormikInputComponent} placeholder="RLB LEDGER GSTIN" readOnly={true} className="readOnly"></Field>
                            <DiscountOptions name="vb_discount_field" placeholder="Vehicle Booking Discount Field" isTxn={false} label="Vehicle Booking Discount Field" isSelection={true} />
                        </Form.Group>

                        <Form.Group widths={3} style={{ paddingBottom: "10px" }}>
                            {ledgermap && ledgermap.exception_for_tax_computation === 1 ?
                                <>
                                    <Field name="exception_for_tax_computation" label="Exceptional ledger for tax computation (DBT/CRT)" setToggle={setTaxComputationToggle} isChecked={true} component={FormikCheckBoxComponent}></Field>
                                </> :
                                <>
                                    <Field name="exception_for_tax_computation" label="Exceptional ledger for tax computation (DBT/CRT)" setToggle={setTaxComputationToggle} component={FormikCheckBoxComponent}></Field>
                                </>
                            }
                        </Form.Group>

                        {ledgermap ? (ledgermap.dr_msil || ledgermap.dr_msil_code || ledgermap.cr_msil || ledgermap.cr_msil_code || ledgermap.dler_disc || ledgermap.dler_disc_code || ledgermap.control_ldgr || ledgermap.control_ldgr_code) ?
                            <Form.Group widths={2} style={{ paddingBottom: "7px" }}>
                                <Field name="msilToggle" label="MSIL MAP" setToggle={setMsilToggle} isChecked={true} component={FormikCheckBoxComponent}></Field>
                            </Form.Group>
                            :
                            <Form.Group widths={2} style={{ paddingBottom: "7px" }}>
                                <Field name="msilToggle" label="MSIL MAP" setToggle={setMsilToggle} component={FormikCheckBoxComponent}></Field>
                            </Form.Group>
                            : null
                        }

                        {
                            (props.match.path === '/ledgermap/edit/:id' || props.match.path === '/ledgermap/clone/:id') ?
                                <>
                                    {
                                        (msilToggle === "yes") ?
                                            <>
                                                <Form.Group widths={4} style={{ paddingBottom: "7px" }}>
                                                    <LedgerSearch name='dr_msil' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='RealBooks: Debit MSIL Ledger' className="ledgerSearch" isMandatory={false} getValue={handleDebitMsilLedgerSelection} onBlurFunction={handleDebitMsilLedgerOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/ledgermap/edit/:id' || props.match.path === '/ledgermap/clone/:id') ? true : false} values={values} componentType="ledgermapForm" cid={values.cid} />
                                                    <Field name="dr_msil_code" label="RealBooks: Debit  MSIL Ledger Code" component={FormikInputComponent} placeholder="Debit  MSIL Ledger Code" readOnly={true} className="readOnly"></Field>
                                                    <LedgerSearch name='dler_disc' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='RealBooks: Dealer Dsicount' className="ledgerSearch" isMandatory={false} getValue={handleDealerDiscountSelection} onBlurFunction={handleDealerDiscountOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/ledgermap/edit/:id' || props.match.path === '/ledgermap/clone/:id') ? true : false} values={values} componentType="ledgermapForm" cid={values.cid} />
                                                </Form.Group>
                                                <Form.Group widths={4} style={{ paddingBottom: "7px" }}>
                                                    <LedgerSearch name='cr_msil' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='RealBooks: Credit MSIL Ledger' className="ledgerSearch" isMandatory={false} getValue={handleCreditMsilLedgerSelection} onBlurFunction={handleCreditMsilLedgerOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/ledgermap/edit/:id' || props.match.path === '/ledgermap/clone/:id') ? true : false} values={values} componentType="ledgermapForm" cid={values.cid} />
                                                    <Field name="cr_msil_code" label="RealBooks: Credit MSIL Ledger Code" component={FormikInputComponent} placeholder="Credit MSIL Ledger Code" readOnly={true} className="readOnly"></Field>
                                                    <Field name="dler_disc_code" label="RealBooks: Dealer Dsicount Code" component={FormikInputComponent} placeholder="Dealer Dsicount Code" readOnly={true} className="readOnly"></Field>
                                                </Form.Group>
                                                <Form.Group widths={4} style={{ paddingBottom: "7px" }}>
                                                    <LedgerSearch name='control_ldgr' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='RealBooks: Controling Ledger' className="ledgerSearch" isMandatory={false} getValue={handleControllingLedgerSelection} onBlurFunction={handleControllingLedgerOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/ledgermap/edit/:id' || props.match.path === '/ledgermap/clone/:id') ? true : false} values={values} componentType="ledgermapForm" cid={values.cid} />
                                                    <Field name="control_ldgr_code" label="RealBooks: Controling Ledger Code" component={FormikInputComponent} placeholder="Controling Ledger Code" readOnly={true} className="readOnly"></Field>
                                                </Form.Group>
                                            </>
                                            : null
                                    }
                                </>
                                :
                                <>
                                    {ledgermap ?
                                        ((ledgermap.dr_msil || ledgermap.dr_msil_code || ledgermap.cr_msil || ledgermap.cr_msil_code || ledgermap.dler_disc || ledgermap.dler_disc_code || ledgermap.control_ldgr || ledgermap.control_ldgr_code) || msilToggle === "yes") ?
                                            <>
                                                <Form.Group widths={4} style={{ paddingBottom: "7px" }}>
                                                    <LedgerSearch name='dr_msil' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='RealBooks: Debit MSIL Ledger' className="ledgerSearch" isMandatory={false} getValue={handleDebitMsilLedgerSelection} onBlurFunction={handleDebitMsilLedgerOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/ledgermap/edit/:id' || props.match.path === '/ledgermap/clone/:id') ? true : false} values={values} componentType="ledgermapForm" cid={values.cid} />
                                                    <Field name="dr_msil_code" label="RealBooks: Debit  MSIL Ledger Code" component={FormikInputComponent} placeholder="Debit  MSIL Ledger Code" readOnly={true} className="readOnly"></Field>
                                                    <LedgerSearch name='dler_disc' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='RealBooks: Dealer Dsicount' className="ledgerSearch" isMandatory={false} getValue={handleDealerDiscountSelection} onBlurFunction={handleDealerDiscountOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/ledgermap/edit/:id' || props.match.path === '/ledgermap/clone/:id') ? true : false} values={values} componentType="ledgermapForm" cid={values.cid} />
                                                </Form.Group>
                                                <Form.Group widths={4} style={{ paddingBottom: "7px" }}>
                                                    <LedgerSearch name='cr_msil' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='RealBooks: Credit MSIL Ledger' className="ledgerSearch" isMandatory={false} getValue={handleCreditMsilLedgerSelection} onBlurFunction={handleCreditMsilLedgerOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/ledgermap/edit/:id' || props.match.path === '/ledgermap/clone/:id') ? true : false} values={values} componentType="ledgermapForm" cid={values.cid} />
                                                    <Field name="cr_msil_code" label="RealBooks: Credit MSIL Ledger Code" component={FormikInputComponent} placeholder="Credit MSIL Ledger Code" readOnly={true} className="readOnly"></Field>
                                                    <Field name="dler_disc_code" label="RealBooks: Dealer Dsicount Code" component={FormikInputComponent} placeholder="Dealer Dsicount Code" readOnly={true} className="readOnly"></Field>
                                                </Form.Group>
                                                <Form.Group widths={4} style={{ paddingBottom: "7px" }}>
                                                    <LedgerSearch name='control_ldgr' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='RealBooks: Controling Ledger' className="ledgerSearch" isMandatory={false} getValue={handleControllingLedgerSelection} onBlurFunction={handleControllingLedgerOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/ledgermap/edit/:id' || props.match.path === '/ledgermap/clone/:id') ? true : false} values={values} componentType="ledgermapForm" cid={values.cid} />
                                                    <Field name="control_ldgr_code" label="RealBooks: Controling Ledger Code" component={FormikInputComponent} placeholder="Controling Ledger Code" readOnly={true} className="readOnly"></Field>
                                                </Form.Group>
                                            </>
                                            : null : null
                                    }
                                </>
                        }
                        <Button type="submit" size="medium" color="blue" className="CustomeBTN"> {params.submitButtonText} </Button>
                        {savedLedgermapId ?
                            <Notification id={savedLedgermapId} resetForm={resetForm} notifySelector={getNotification} notifyDoneAction={setNotifyDone} type='save' />
                            :
                            null}
                    </Form>
                )}
            />
        </div>
    )
}

export default LedgermapForm;
